import { injectable, inject } from '@patsnap/tahiti-core/shared/inversify';
import { PageApi } from '@/infrastructure/api-functions/page-api';
import { PageModel } from './page-model';
import type { CreateFMEAOutput, PageModelData, SummaryOutput } from '@/types';

export const PageService = Symbol('PageService');

export interface PageService {
    update(key: keyof PageModelData, val: any): PageModelData;
    summaryTitle(input: CreateFMEAOutput): Promise<SummaryOutput>;
    reset(): PageModelData;
}

@injectable()
export class PageServiceImpl implements PageService {
    constructor(
        @inject(PageApi)
        private pageApi: PageApi,
        @inject(PageModel)
        private _PageModel: PageModel
    ) {
    }

    update(key: keyof PageModelData, val: any) {
        if (this._PageModel.modelData[key] !== val) {
            this._PageModel.update((value) => {
                return {
                    ...value,
                    [key]: val,
                }
            })
        }
        return this._PageModel.modelData;
    }

    reset() {
        this._PageModel.reset();
        return this._PageModel.modelData;
    }

    async summaryTitle(input: CreateFMEAOutput): Promise<SummaryOutput> {
        const data = await this.pageApi.summaryTitle(input)
        this._PageModel.update(m => {
            return {
                ...m,
                title: data.title,
            }
        })
        return data;
    }
}
